import { PAGE_INTEGRATION_LIST_LOADING } from '../../actions/page/integration/IntegrationList';

const initialState = {
  loading: true
};

export default function IntegrationList(state = initialState, action) {
  switch (action.type) {
    case PAGE_INTEGRATION_LIST_LOADING:
      return {
        loading: action.loading
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/XIntegrationList.js